import { qs, on } from './utils';

const HEADER_SCROLL_THRESHOLD = 100;

export function initHeaderScrollState() {
  const header = qs('.site-header');
  if (!header) return;

  let ticking = false;

  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > HEADER_SCROLL_THRESHOLD);
    ticking = false;
  }

  on(window, 'scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  update();
}

export function initNavigation() {
  const header      = qs('.site-header');
  const menuToggle  = qs('.menu-toggle');
  const mobileMenu  = qs('#mobile-menu');
  const mobileOverlay = qs('.mobile-menu-overlay');

  // ── Mobile menu ──────────────────────────────────────────────────────────

  function openMobileMenu() {
    header?.classList.add('is-open');
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    menuToggle.classList.add('is-open');
    mobileOverlay?.classList.add('is-open');
    document.body.classList.add('menu-open');
  }

  function closeMobileMenu() {
    header?.classList.remove('is-open');
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }

  if (menuToggle && mobileMenu) {
    on(menuToggle, 'click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    // Close when a nav link is tapped
    on(mobileMenu, 'click', (e) => {
      if (e.target.closest('a')) closeMobileMenu();
    });
  }

  if (mobileOverlay) {
    on(mobileOverlay, 'click', closeMobileMenu);
  }

  // ── Global close triggers ────────────────────────────────────────────────

  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileMenu();
    }
  });

  on(document, 'click', (e) => {
    const header = qs('.site-header');
    if (header && !header.contains(e.target)) {
      closeMobileMenu();
    }
  });
}
